export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11069.dd69b1a7.jpg";